import { useForm, useWatch } from 'react-hook-form';
import { ThemeButton } from '@shared/ui/buttons';
import { DialogContent, DialogActions } from '@mui/material';
import { useState } from 'react';
import { validateServerErrors } from '@utils/validation';
import { useTranslation } from 'react-i18next';
import { CodePinInput } from '@shared/ui/forms/inputs';

export default function RequestTwofaDialog({
  close,
  data,
  backToAction,
  action,
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      google2fa_code: '',
    },
  });

  const twoFaCodeWatch = useWatch({ control, name: 'google2fa_code' });

  async function onSubmit(formData) {
    const payload = { ...formData, ...data };
    try {
      setLoading(true);
      const res = await action(payload);
      if (res) close();
    } catch (err) {
      if (err?.response?.data?.errors?.google2fa_code) {
        validateServerErrors(setError, err);
      } else if (backToAction) {
        backToAction(err);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <DialogContent className="twoFa">
        <CodePinInput
          control={control}
          name="google2fa_code"
          error={errors['google2fa_code']}
          label={t('enter_2fa_code')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            onClick={() => {
              if (backToAction) {
                backToAction(null);
              }
            }}
            appearance="secondary"
            startIcon="arrow-left"
          >
            {t('back')}
          </ThemeButton>
          <ThemeButton
            onClick={handleSubmit(onSubmit)}
            startIcon="check"
            loading={loading}
            disabled={twoFaCodeWatch.length < 6}
          >
            {t('submit')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
